import React from "react";
import Select from "react-select";

interface SelectProps {
  id: string;
  options: {
    enumOptions: Array<{
      value: string;
      label: string;
    }>;
  };
  value: string;
  onChange: (value: string) => void;
}

const FormSelect: React.FC<SelectProps> = ({
  id,
  options,
  value,
  onChange,
}) => {
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      maxWidth: "97.5%",
      display: "flex",
      alignItems: "center",
      border: "none",
      backgroundColor: "#0c1835", // pulse-bg-color--background-800
      color: "#b6bdce", // pulse-color--background-600
    }),
    input: (provided: any) => ({
      ...provided,
      color: "#b6bdce", // pulse-color--background-600
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      maxWidth: "80%",
      color: "#b6bdce", // pulse-color--background-600
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      maxWidth: "20%",
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "#0c1835", // pulse-bg-color--background-800
      color: "#b6bdce", // pulse-color--background-600
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#b6bdce", // pulse-color--background-600
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#152b61" : "#0c1835", // pulse-bg-color--background-800
      color: "#b6bdce", // pulse-color--background-600
    }),
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: "200px",
    }),
  };

  const handleChange = (selectedOption: any) => {
    onChange(selectedOption ? selectedOption.value : "");
  };

  const selectedValue = options.enumOptions.find(
    (option) => option.value === value
  );

  return (
    <Select
      id={id}
      name={id}
      styles={customStyles}
      value={selectedValue}
      onChange={handleChange}
      options={options.enumOptions}
      placeholder="Select..."
      isClearable
    />
  );
};

export default FormSelect;
